export const ELEMENT_VIEWED = 'ELEMENT_VIEWED';

export const elementViewed = element => ({
    type: ELEMENT_VIEWED,
    element
});
